<template>
  <div class="plat-student-course-info">
    <StudentCoursePanel ref="panel"
                        v-bind="$attrs"
                        v-on="$listeners"
                        @start-refresh="startRefresh"
                        @end-refresh="endRefresh"></StudentCoursePanel>
  </div>
</template>

<script>
import StudentCoursePanel from '../../../../../../wrapper/panel/student/course'
import Dashboard from '../../../../../../../../../../mixins/custom/dashboard'
export default {
  name: 'PlatStudentCourseInfo',
  mixins: [Dashboard],
  components: {
    StudentCoursePanel
  },
  methods: {
    handleRefresh () {
      if (this.isCurrent) {
        const panel = this.$refs.panel
        if (panel) {
          panel.loadCourseInfo()
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .plat-student-course-info {
    height: 100%;
  }
</style>
